import { createMetricsFactory } from 'metrics-js';
import { getIsAcceptanceTest } from './testUtils';
export const Metrics = createMetricsFactory('pricing-pages-ui', {
  dimensions: {
    isAcceptanceTest: `${getIsAcceptanceTest()}`
  }
});